<div class="committed-exchanges-container container-fluid">
  <router-outlet></router-outlet>
</div>
